var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"input-value":_vm.value,"value":_vm.value,"label":_vm.label,"name":_vm.name},on:{"change":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }